/* [PATCH vod-veza-interna v1] [PATCH vod-veza-interna v3] besedilo brez VOD/Opal. Nastavitve -> Izdani racuni -> "Veza = interna stevilka racuna".
   Ce je vklopljeno, VOD izvoz izdanih dobi <Dobav_stevilka_dokumenta> = interna stevilka (Opal: polje Veza).
   Privzeto IZKLOPLJENO = dosedanje vedenje. Shranjuje se SPROTI (PUT /profil/{cid} samo s tem poljem; exclude_none).
   Klon PrenosPdfKartica.tsx. */
import { useState, useEffect } from 'react';
import { api } from '../../lib/api';
import { Link2 } from 'lucide-react';

export function VezaInternaKartica({ companyId }: { companyId: string }) {
  const [vklop, setVklop] = useState(false);   // privzetek = dosedanje vedenje (brez Veze)
  const [spor, setSpor] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    api.get(`/profil/${companyId}`)
      .then(r => setVklop(r.data?.izdani_vod_veza === true))
      .catch(() => {});
  }, [companyId]);

  const preklopi = async () => {
    if (busy) return;
    const novo = !vklop;
    setBusy(true); setSpor('');
    try {
      await api.put(`/profil/${companyId}`, { izdani_vod_veza: novo });
      setVklop(novo);
      setSpor(novo ? 'Shranjeno: Veza se izvaža.' : 'Shranjeno: Veza se ne izvaža.');
    } catch {
      setSpor('Napaka pri shranjevanju.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-6 max-w-2xl">
      <div className="flex items-center gap-3 mb-1">
        <div className="w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-950 flex items-center justify-center text-blue-600 dark:text-blue-400">
          <Link2 className="w-5 h-5" />
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 dark:text-white">Veza = interna številka računa</h2>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Ob prenosu izdanih računov se v polje Veza zapiše interna številka računa, kot je bila prevzeta ob uvozu
            (Opal: element Dobav_stevilka_dokumenta in Veza na knjižbah; Vasco: Veza na vseh knjižbah).
            Številka dokumenta in FURS številka ostaneta kot doslej. Dokumenti brez uvožene interne številke se prenesejo kot do zdaj.
          </p>
        </div>
      </div>
      <div className="mt-4 flex items-start gap-3">
        <button
          type="button"
          onClick={preklopi}
          disabled={busy}
          role="switch"
          aria-checked={vklop}
          className={`relative w-12 h-6 rounded-full transition-colors shrink-0 ${vklop ? 'bg-emerald-500' : 'bg-gray-300 dark:bg-gray-700'} ${busy ? 'opacity-60' : ''}`}
        >
          <span className={`absolute top-0.5 w-5 h-5 rounded-full bg-white transition-all ${vklop ? 'left-6' : 'left-0.5'}`} />
        </button>
        <div>
          <div className="text-sm font-medium text-gray-900 dark:text-white">
            {vklop ? 'Veza se izvaža' : 'Veza se ne izvaža'}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            {vklop ? 'Izdani računi v prenosu dobijo Veza = interna številka računa.'
                   : 'Prenos je enak kot doslej (Veza se ne polni z interno številko).'}
          </div>
          {spor && <p className="text-[11px] text-gray-500 mt-1">{spor}</p>}
        </div>
      </div>
      <p className="text-[11px] text-gray-500 mt-3">Nastavitev se shrani sproti (neodvisno od gumba Shrani).</p>
    </div>
  );
}
